import API_URL from '../../constants/url'
import {
  logUtil,
  mergeObjectUtil
} from 'packages/src'
import fetchNetworkUtil from '../../../../utils/network/fetch'

export async function postApi ({
  endpoint,
  data,
  jwt,
  fetchOptions = {}
}) {
  if (!endpoint) {
    logUtil('postApi')
      .error(`no endpoint '${endpoint}': `, data)
    return
  }

  if (!data) {
    logUtil('postApi')
      .error(`no endpoint '${endpoint}': `, data)
    return
  }

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${jwt}`
  }

  const defaultFetchOptions = {
    headers,
    method: 'POST',
    body: JSON.stringify(data)
  }

  if (
    Object.hasOwn(fetchOptions, 'headers') &&
    fetchOptions.headers === undefined
  ) {
    delete defaultFetchOptions.headers
  }

  const options = mergeObjectUtil(defaultFetchOptions, fetchOptions)

  const fetchOptionsHeaders = fetchOptions.headers || {}
  if (
    Object.hasOwn(fetchOptionsHeaders, 'Content-Type') &&
    fetchOptionsHeaders['Content-Type'] === undefined
  ) {
    delete options.headers['Content-Type']
  }

  const response = await fetchNetworkUtil(`${API_URL}${endpoint}`, options)

  if (!response.ok) {
    throw (
      await response.json()
    )
  }
  return response.json()
}
